/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Content/DataUrl/Content/Content"
  
}) {
let dataValueData = fromData.useDataValue({ viewPath,
context: 'data',
})
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 data="data"
 goTo={dataValueData}
 text="Download"
/>
{children}
</React.Fragment>)
}